import { SubscriptionModel } from "~/server/types/server.interface";

export const mapSubscriptionModelToLevels: SubscriptionModel[] = ["archived", "default"];
export const OPEN_NOW_TAG_ID = "Открыто сейчас";
export const FOR_MEN_WOMEN_TAG_ID = "Для мужчин и женщин";
export const NO_EXTRA_CHARGE_TAG_ID = "Без доплаты";
export const FOR_WOMEN_TAG_ID = "Только для женщин";
export const ON_SITE_CHARGE_TAG_ID = "Доплата на объекте";
export const LIMITATION_PROPERTY_TAG_ID = "Limited services";
export const ROUND_THE_CLOCK_TAG_ID = "Круглосуточный";
export const FREE_PARKING_TAG_ID = "Бесплатная парковка";
export const SEASONAL_SERVICE_TAG_ID = "Сезонное обслуживание";
export const RESERVATION_REQUIRED_TAG_ID = "Требуется бронирование";
export const SERVICE_FOR_PARENTS_TAG_ID = "Услуги для родителей с детьми или беременных женщин";
export const WI_FI_TAG_ID = "Wi-Fi";
export const DEFAULT_SUBSCRIPTION_MODEL_ID = 1;
export const ARCHIVED_SUBSCRIPTION_MODEL_ID = 0;
export const SUBSCRIPTION_MODEL_TAB_LIST = [
  { value: "Актуальные", id: DEFAULT_SUBSCRIPTION_MODEL_ID.toString() },
  { value: "Архивные", id: ARCHIVED_SUBSCRIPTION_MODEL_ID.toString() },
];

export const DESKTOP_SCREEN_WIDTH = 1280;
